import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgChartsModule } from 'ng2-charts';

import { IconComponent } from '@shared/components/icon/icon.component';

import {
  TICICChartLabel,
  TICICChartType,
  TrialInsightsClinicalInvestigatorCostChartService,
} from './investigator-cost-chart.service';
import { TrialInsightsClinicalInvestigatorCostQueryService } from './investigator-cost-query.service';
import { TrialInsightsClinicalInvestigatorCostStoreService } from './investigator-cost-store.service';
import { TrialInsightsClinicalInvestigatorCostTableService } from './investigator-cost-table.service';
import { GenericTrialInsightsComponent } from '../../classes/trial-insights-component.class';
import { TrialInsightsHeaderComponent } from '../trial-insights-header/trial-insights-header.component';
import { TrialInsightsTableComponent } from '../trial-insights-table/trial-insights-table.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TrialInsightsHeaderComponent,
    IconComponent,
    NgStyle,
    NgChartsModule,
    TrialInsightsTableComponent,
  ],
  providers: [TrialInsightsClinicalInvestigatorCostQueryService],
  selector: 'aux-trial-insights-clinical-investigator-cost',
  styleUrls: ['../../trial-insights.component.scss'],
  templateUrl: './investigator-cost.component.html',
})
export class TrialInsightsClinicalInvestigatorCostComponent extends GenericTrialInsightsComponent<
  TICICChartType,
  TICICChartLabel
> {
  storeService = inject(TrialInsightsClinicalInvestigatorCostStoreService);

  cdr: ChangeDetectorRef;
  chartService: TrialInsightsClinicalInvestigatorCostChartService;
  queryService: TrialInsightsClinicalInvestigatorCostQueryService;
  tableService: TrialInsightsClinicalInvestigatorCostTableService;

  constructor() {
    const tableService = inject(TrialInsightsClinicalInvestigatorCostTableService);
    const chartService = inject(TrialInsightsClinicalInvestigatorCostChartService);
    const queryService = inject(TrialInsightsClinicalInvestigatorCostQueryService);
    const cdr = inject(ChangeDetectorRef);

    super({
      cdr,
      chartService,
      color: '#226262',
      queryService,
      tableService,
      title: 'Investigator Costs to Date',
    });

    this.tableService = tableService;
    this.chartService = chartService;
    this.queryService = queryService;
    this.cdr = cdr;
  }

  subscribeToData = () => {
    this.queryService
      .processTotalInvestigatorCosts$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
    this.storeService
      .getTotalInvestigatorCosts$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  };
}
